import React, { useEffect, useState } from 'react';
import { useServicesContext } from '../../../context';
import { useI18n } from '@oneaudi/i18n-context';
import { LayerContentHTML } from '@oneaudi/fa-one-layer';
import { InfoTextContainer } from '../styles/InfoButton.styles';
import { trackClicks } from '../tracking';
import { useScsUrlParts } from '../../../hooks';
import { Text, IconButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { dynamicStyling, dynamicStylingHelper, DynamicThemeProviderWrapper } from '../../utils';
const InfoButton = ({ filterGroupIdOrFilterId, filterOrGroupText, filterCategory, isNextToRangeFilter, isColorTypeCheckbox, isPlpQuickFilters, }) => {
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const layerManager = useServicesContext().getAdditionalService('layer-manager');
    const [campaignMicroSiteUrl, setCampaignMicroSiteUrl] = useState('');
    const [layerLinkConfig, setLayerLinkConfig] = useState(null);
    const { scsBaseUrl, defaultVersion, marketPath } = useScsUrlParts();
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const { filterInfoLayers } = audiContentService.getContent().fields;
    useEffect(() => {
        const layerLink = filterInfoLayers === null || filterInfoLayers === void 0 ? void 0 : filterInfoLayers.find(({ fields }) => { var _a; return (_a = fields.selectedFilterOrGroup) === null || _a === void 0 ? void 0 : _a.includes(filterGroupIdOrFilterId); });
        if (layerLink) {
            setLayerLinkConfig(layerLink.fields);
        }
        if (filterGroupIdOrFilterId.startsWith('campaign.')) {
            const campaignId = filterGroupIdOrFilterId.replace('campaign.', '');
            fetch(`${scsBaseUrl}${defaultVersion}/structure/campaigns/${marketPath}?svd=1`)
                .then((response) => {
                if (!response.ok) {
                    throw new Error('Scs Campaign api threw an error');
                }
                return response.json();
            })
                .then((data) => {
                const campaignContent = data === null || data === void 0 ? void 0 : data.find((campaignEntry) => campaignEntry.campaignId === campaignId);
                if (campaignContent) {
                    setCampaignMicroSiteUrl(campaignContent.micrositeUrl);
                }
            })
                .catch((error) => {
                console.error('There was a problem with fetching campaigns:', error);
            });
        }
    }, [filterGroupIdOrFilterId]);
    const infoButtonId = `infoButton-${filterGroupIdOrFilterId}`.split('.').join('');
    const tooltipText = useI18n({
        id: `nemo.sc.filter.${filterGroupIdOrFilterId}.tooltipText`,
        defaultMessage: '',
    });
    const infoButtonariaText = useI18n({
        id: `nemo.sc.filter.infoButton.ariaText`,
        defaultMessage: 'Additional information about {{filter}}.',
    }).replace('{{filter}}', filterOrGroupText);
    const hasCompleteLayerContent = (campaignMicroSiteUrl && infoButtonariaText) || (layerLinkConfig && infoButtonariaText);
    const hasCompleteTooltipText = tooltipText && infoButtonariaText;
    const openTooltipLayer = () => {
        const trackingEventName = 'vtp filter - click on info i';
        trackClicks(trackingService, trackingEventName, `${filterOrGroupText}`, 'icon', `${filterCategory}`, true);
        layerManager.openFocusLayer(() => (React.createElement(DynamicThemeProviderWrapper, null,
            React.createElement(InfoTextContainer, null,
                React.createElement(Text, null, tooltipText)))), {}, {
            userCloseable: true,
            size: "B",
            onClose: () => {
                setTimeout(() => document === null || document === void 0 ? void 0 : document.getElementById(infoButtonId).focus());
            },
        });
    };
    const openIFrameLayer = () => {
        const trackingEventName = 'vtp filter - click on info i';
        const layerLinkUrl = campaignMicroSiteUrl || (layerLinkConfig === null || layerLinkConfig === void 0 ? void 0 : layerLinkConfig.layerContentUrl);
        trackClicks(trackingService, trackingEventName, `${filterOrGroupText}`, 'icon', `${filterCategory}`, true);
        if (layerLinkUrl) {
            layerManager.openFocusLayer(() => React.createElement(LayerContentHTML, { url: layerLinkUrl, withFefa: true }), {}, {
                userCloseable: true,
                size: "B",
                onClose: () => {
                    setTimeout(() => document === null || document === void 0 ? void 0 : document.getElementById(infoButtonId).focus());
                },
            });
        }
    };
    const getButtonWithIFrameLayer = () => (React.createElement(StyledIconButton, { variant: "tertiary", size: isPlpQuickFilters ? dynamicStylingHelper('md', 'xs') : 'md', onClick: openIFrameLayer, "data-testid": "filterInfoLayerIFrame", icon: "info-circle", key: `infobutton-${filterGroupIdOrFilterId}`, "aria-label": infoButtonariaText, id: infoButtonId, isLegacy: dynamicStylingHelper(true, false), isNextToRangeFilter: isNextToRangeFilter, isColorTypeCheckbox: isColorTypeCheckbox }));
    const getButtonWithTooltipLayer = () => (React.createElement(StyledIconButton, { variant: "tertiary", size: isPlpQuickFilters ? dynamicStylingHelper('md', 'xs') : 'md', onClick: openTooltipLayer, "data-testid": "filterInfoLayerTooltip", icon: "info-circle", key: `infobutton-${filterGroupIdOrFilterId}`, "aria-label": infoButtonariaText, id: infoButtonId, isLegacy: dynamicStylingHelper(true, false), isNextToRangeFilter: isNextToRangeFilter, isColorTypeCheckbox: isColorTypeCheckbox }));
    if (hasCompleteLayerContent) {
        return getButtonWithIFrameLayer();
    }
    if (hasCompleteTooltipText) {
        return getButtonWithTooltipLayer();
    }
    return null;
};
export default InfoButton;
const StyledIconButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) `
  > button {
    ${dynamicStyling({
    legacy: `
        width: unset;
        height: unset;
        `,
})}
    margin-left: ${dynamicStylingHelper('16px', '')};
    position: ${dynamicStylingHelper('static', 'relative')};
    top: ${(props) => !props.isLegacy && props.isColorTypeCheckbox
    ? dynamicStylingHelper('-10px', '-6px')
    : !props.isLegacy && !props.isNextToRangeFilter && dynamicStylingHelper('-15px', '-6px')};
  }
`;
